import { useMemo } from "react";
import { SortDescriptor } from "react-aria-components";

import { compareUsedByRows, WorkerPoolUsedByRow } from "./helpers";

const sortScanRows = (
  rows: WorkerPoolUsedByRow[],
  sortDescriptor: SortDescriptor
): WorkerPoolUsedByRow[] => {
  if (!sortDescriptor.column) {
    return rows;
  }

  return [...rows].sort((a, b) => compareUsedByRows(a, b, sortDescriptor));
};

export const useFilteredScans = (
  rows: WorkerPoolUsedByRow[],
  sortDescriptor: SortDescriptor,
  searchQuery: string
): WorkerPoolUsedByRow[] => {
  return useMemo(() => {
    let filteredRows = rows;

    if (searchQuery) {
      filteredRows = filteredRows.filter((row) =>
        row.name.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    return sortScanRows(filteredRows, sortDescriptor);
  }, [rows, searchQuery, sortDescriptor]);
};
